import { simpleInstance, uploadInstance } from '@/api/instances'

/**
 * Upload file passing the file, personId and domain
 * @param  _
 * @param {object} file, personId and domain
 * @returns object file
 */
const uploadFileByDomain = async (_, { file, personId, domain }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('personId', personId)
  formData.append('fileName', file.name)

  return await uploadInstance.post(
    `${process.env.VUE_APP_FILE_VAULT_API_PREFIX_URL}/${domain}/file`,
    {
      json: formData
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

/**
 * Upload file using 'channel' domain
 * @param {store object} store
 * @param {object} with file and personId
 * @returns object file
 */
const uploadFile = async (store, { file, personId }) => {
  return await store.dispatch('uploadFileByDomain', {
    file,
    personId,
    domain: 'channel'
  })
}

/**
 * Pass file-vault url and return the file object
 * @param  _
 * @param {string} url
 * @returns file url
 */
const getFile = async (_, url) => {
  return await simpleInstance.get(url)
}

/**
 * Pass array of ids and return the files object array
 * @param _
 * @param {Array} ids
 * @returns Array of file objects
 */
const getFileInBatch = async (_, ids) => {
  return await simpleInstance.get(
    `${process.env.VUE_APP_FILE_VAULT_API_PREFIX_URL}/file/batch?ids=${ids}`
  )
}

export default {
  uploadFileByDomain,
  uploadFile,
  getFile,
  getFileInBatch
}
